import dayjs from 'dayjs'
import { createSignal, onMount, onCleanup, Index } from 'solid-js'
import { Portal } from 'solid-js/web'
import { res2json } from '@/utils'
import { events, WALLETS_APPLY, WALLETS_OPERATED } from '@/store/messenger'
import { playAlert, togglePlayAlert } from '@/store/play_alert'
import { NotificationsOutline, NotificationsOffOutline } from '@/icons'

const requests = {
  deposit: '上分',
  withdrawal: '下分'
}

export default function Pending() {
  const [rows, setRows] = createSignal([])

  const [loading, setLoading] = createSignal(true)

  async function load() {
    setLoading(true)
    return fetch('/api/pending').then(res2json).then(r => { setRows(r.data ?? []) }).finally(() => { setLoading(false) })
  }
  onMount(() => {
    load()

    events.on(WALLETS_APPLY, load)
    events.on(WALLETS_OPERATED, load)
  })
  onCleanup(() => {
    events.removeListener(WALLETS_APPLY, load)
    events.removeListener(WALLETS_OPERATED, load)
  })

  async function approve(row, index) {
    fetch(`/api/pending/${row().transaction_id}/approve`, { method: 'POST' })
    setRows(e => {
      e.splice(index, 1)
      return [...e]
    })
  }

  async function reject(row, index) {
    fetch(`/api/pending/${row().transaction_id}/reject`, { method: 'POST' })
    setRows(e => {
      e.splice(index, 1)
      return [...e]
    })
  }

  return (
    <>
      <div class="flex flex-col gap-4">
        <div class="breadcrumbs text-sm">
          <ul>
            <li><a href="/home">后台首页</a></li>
            <li>上下分确认</li>
          </ul>
        </div>
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-2">
            <h2 class="text-xl">上下分确认</h2>
            {playAlert() ? (<span role="button" onClick={() => togglePlayAlert()} class="w-5"><NotificationsOutline /></span>) : (<span role="button" onClick={() => togglePlayAlert()} class="w-5"><NotificationsOffOutline /></span>)}
          </div>
        </div>
        <div class="overflow-x-auto">
          <table class="table whitespace-nowrap">
            <thead>
              <tr class="bg-base-200">
                <th>用户名(昵称)</th>
                <th>操作</th>
                <th class="text-right">金额</th>
                <th class="text-right">积分</th>
                <th class="text-right">申请时间</th>
              </tr>
            </thead>
            <tbody>
              <Index each={rows()}>
                {(row, index) => (
                  <>
                    <tr class="hover:bg-base-200">
                      <td class="px-2 lg:px-3">{row().player.username}({row().player.nickname})</td>
                      <td class="px-2 lg:px-3">{requests[row().request] ?? row().request}</td>
                      <td class="px-2 lg:px-3 text-right">{(row().score / 100).toFixed(2)}</td>
                      <td class="px-2 lg:px-3 text-right">{(row().player.score / 100).toFixed(2)}</td>
                      <td class="px-2 lg:px-3 text-right">{row().created_at ? dayjs(row().created_at * 1000).format('YYYY-MM-DD HH:mm:ss') : '-'}</td>
                    </tr>
                    <tr>
                      <td class="px-2 lg:px-3" colspan="5">
                        <div class="flex items-center justify-start md:justify-end gap-2">
                          <button type="button" onClick={() => approve(row, index)} class="btn btn-success text-white btn-sm">同意</button>
                          <button type="button" onClick={() => reject(row, index)} class="btn btn-error text-white btn-sm">拒绝</button>
                        </div>
                      </td>
                    </tr>
                  </>
                )}
              </Index>
            </tbody>
          </table>
        </div>
      </div>

      <Portal mount={document.body}>
        {loading() && (<div class="fixed left-2 right-2 bottom-0"><progress class="progress progress-success w-full"></progress></div>)}
      </Portal>
    </>
  )
}
